import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import AddIcon from "@mui/icons-material/Add";
import { useEffect, useState } from "react";
import ArrowBackIosNewRoundedIcon from "@mui/icons-material/ArrowBackIosNewRounded";
import DynamicForm from "../../common/DynamicForm";
import { useForm } from "react-hook-form";
import AddMetadataFieldForm from "./AddMetadataFieldForm";
import { DataGridComponent } from "../../common/DataGridComponent";
// import { Stack } from "@mui/material";
import { ColumnType } from "../../../types/dataGridTypes";
import { useEntity } from "./useEntity";
import { useSnackbar } from "../../../hooks/useSnackbar";
import { addNewEntitySchema } from "./metadataSchema";
import { zodResolver } from "@hookform/resolvers/zod";
import Loader from "../../common/Loader/Loader";
import { hideLoader, showLoader } from "../../../store/slices/loaderSlice";
import { useAppDispatch } from "../../../store";
// import { zodResolver } from "@hookform/resolvers/zod";

const MetadataStudyPage = (props: any) => {
  const { selectedEntity, setSelectedEntity, allCodelistData } = props;
  const [rows, setRows] = useState([]);
  const [openMetadataField, setOpenMetadataField] = useState(false);
  const [selectedFieldData, setSeletedFieldData] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const { handleError, showSuccess } = useSnackbar();
  const dispatch = useAppDispatch();

  const {
    getSelectedEntityDetails,
    selectEntityData,
    selectEntityIsLoading,
    selectEntityIsSuccess,
    selectEntityIsError,
    selectEntityError,
    createEntity,
    createEntityIsSuccess,
    createEntityError,
    updateEntity,
    updateEntityIsSuccess,
    updateEntityError,
    createAlembicRevision,
    createAlembicRevisionIsSuccess,
    createAlembicRevisionError,
    upgradeAlembicRevision,
    upgradeAlembicRevisionIsSuccess,
    upgradeAlembicRevisionError,
  } = useEntity();

  useEffect(() => {
    if (
      selectedEntity &&
      selectedEntity != "new" &&
      selectedEntity != getValues("entity_name")
    ) {
      getSelectedEntityDetails({ table_name: selectedEntity.entity_name });
    }
  }, [selectedEntity]);

  useEffect(() => {
    if (selectEntityIsLoading) {
      setIsLoading(true);
    } else {
      setIsLoading(false);
    }
  }, [selectEntityIsLoading]);

  useEffect(() => {
    if (selectEntityError) {
      const error: any = selectEntityError;
      handleError(error);
    }
  }, [selectEntityIsError]);

  useEffect(() => {
    if (selectEntityData && selectEntityIsSuccess) {
      setRows(
        selectEntityData.fields?.map((item: any) => {
          return {
            ...item,
            id: item.field_name,
            required: item.nullable ? "No" : "Yes",
          };
        })
      );
    }
  }, [selectEntityData, selectEntityIsSuccess]);

  const values =
    selectedEntity == "new"
      ? {}
      : {
          entity_name: selectedEntity?.entity_name,
          parent: selectedEntity?.parent,
          description: selectedEntity?.description,
        };

  const {
    control,
    handleSubmit,
    register,
    formState: { errors },
    getValues,
  } = useForm({
    resolver: zodResolver(addNewEntitySchema),
    defaultValues: values,
  });

  const columns: ColumnType[] = [
    // { field: "id", headerName: "ID", width: 120, cmp: "link" },
    { field: "field_name", headerName: "Name", width: 150, cmp: "link" },
    {
      field: "field_type",
      headerName: "Type",
      width: 140,
      // editable: true,
      // type: "singleSelect",
      // valueOptions: ["UUID", "String", "Numeric", "Bolean"],
    },
    {
      field: "description",
      headerName: "Description",
      minWidth: 150,
      flex: 1,
    },
    {
      field: "required",
      headerName: "Required",
      width: 100,
      type: "singleSelect",
      valueOptions: ["Yes", "No"],
    },
    {
      field: "parent",
      headerName: "Reference Entity",
      width: 160,
    },
    {
      field: "title",
      headerName: "Record ID Display",
      width: 160,
    },
    {
      field: "max_length",
      headerName: "Max Length",
      width: 100,
      type: "number",
    },
  ];

  const metadataHeaderFields = [
    {
      groupName: "metadata_header",
      fields: [
        {
          label: "Name",
          name: "entity_name",
          required: true,
          size: 6,
        },
        {
          label: "Parent",
          name: "parent",
          size: 6,
        },
        {
          label: "Description",
          name: "description",
          required: true,
          size: 12,
        },
      ],
    },
  ];

  const actions = {
    field_name: (data: any) => {
      setSeletedFieldData(data);
      setOpenMetadataField(true);
    },
  };

  const handleSaveEntity = (data: any) => {
    if (selectedEntity != "new") {
      const columns_to_be_added = rows.filter(
        (data: any) =>
          !selectEntityData.fields.find(
            (item: any) => item.field_name == data.field_name
          )
      );

      updateEntity({
        data: { entity_name: data.entity_name, columns_to_be_added },
      });
    } else {
      const modifiedRows = rows.map((item: any) => {
        delete item.id;
        const nullable = item.required == "Yes" ? false : true;
        delete item.required;
        return { ...item, nullable };
      });
      const temp = { ...data, is_base: true, fields: modifiedRows };
      createEntity({ data: temp });
    }
    dispatch(showLoader());
  };

  useEffect(() => {
    if (createEntityIsSuccess || updateEntityIsSuccess) {
      setTimeout(() => {
        createAlembicRevision({
          data: { tables: [getValues("entity_name")] },
        });
      }, 1500);
    }
  }, [createEntityIsSuccess, updateEntityIsSuccess]);

  useEffect(() => {
    if (createAlembicRevisionIsSuccess) {
      setTimeout(() => {
        upgradeAlembicRevision({
          data: { tables: [getValues("entity_name")] },
        });
      }, 1500);
    }
  }, [createAlembicRevisionIsSuccess]);

  useEffect(() => {
    if (upgradeAlembicRevisionIsSuccess) {
      selectedEntity == "new"
        ? showSuccess("Enity is created successfully")
        : showSuccess("Enity is updated successfully");
      setSelectedEntity(getValues("entity_name"));
      dispatch(hideLoader());
    }
  }, [upgradeAlembicRevisionIsSuccess]);

  useEffect(() => {
    if (
      createEntityError ||
      updateEntityError ||
      createAlembicRevisionError ||
      upgradeAlembicRevisionError
    ) {
      const error: any =
        createEntityError ||
        updateEntityError ||
        createAlembicRevisionError ||
        upgradeAlembicRevisionError;
      handleError(error);
      dispatch(hideLoader());
    }
  }, [
    createEntityError,
    updateEntityError,
    createAlembicRevisionError,
    upgradeAlembicRevisionError,
  ]);

  const OnInvalid = (data: any) => {
    console.debug(data);
  };

  return (
    <>
      <Loader />
      <Button
        startIcon={<ArrowBackIosNewRoundedIcon />}
        size="small"
        sx={{ mb: 1 }}
        onClick={() => setSelectedEntity(null)}
      >
        Back
      </Button>
      <fieldset
        disabled={selectedEntity != "new"}
        style={{ border: "none", padding: 0 }}
      >
        <DynamicForm
          fieldsJson={metadataHeaderFields}
          control={control}
          register={register}
          errors={errors}
          groups
        />
      </fieldset>

      <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 2 }}>
        <Button
          variant="contained"
          startIcon={<AddIcon />}
          onClick={() => setOpenMetadataField(true)}
        >
          Add Field
        </Button>
      </Box>
      <Box
        sx={{
          height: 350,
          width: "100%",
          "& .actions": {
            color: "text.secondary",
          },
          "& .textPrimary": {
            color: "text.primary",
          },
        }}
      >
        <DataGridComponent
          rows={rows}
          columns={columns as any}
          hideFooter
          hideFooterRowCount
          hideFooterSelectedRowCount
          hideFooterPagination
          hasDefinedColumns={false}
          actions={actions}
          loading={isLoading}
          showQuickFilter
        />
      </Box>
      <Box className="footerStickyBtnWrap dFlex justifyContentEnd">
        <Button
          variant="contained"
          sx={{ mb: 1 }}
          onClick={handleSubmit(handleSaveEntity, OnInvalid)}
          disabled={
            selectedEntity == "new"
              ? rows?.length == 0
              : rows.filter(
                  (data: any) =>
                    !selectEntityData?.fields?.find(
                      (item: any) => item.field_name == data.field_name
                    )
                ).length == 0
          }
        >
          Save
        </Button>
      </Box>
      {openMetadataField && (
        <AddMetadataFieldForm
          openMetadataField={openMetadataField}
          setOpenMetadataField={setOpenMetadataField}
          setRows={setRows}
          rows={rows}
          selectedFieldData={selectedFieldData}
          setSeletedFieldData={setSeletedFieldData}
          selectedEntity={selectedEntity}
          allCodelistData={allCodelistData}
        />
      )}
    </>
  );
};

export default MetadataStudyPage;
